module.exports = {
    SET_LOADING: "SET_LOADING",
    SET_ERROR: "SET_ERROR",
    SET_DATA: "SET_DATA",
    SET_LOADING_OFFERS_SELECTED: "SET_LOADING_OFFERS_SELECTED",
    SET_ERROR_OFFERS_SELECTED: "SET_ERROR_OFFERS_SELECTED",
    SET_DATA_OFFERS_SELECTED: "SET_DATA_OFFERS_SELECTED",
    RESET: "RESET",
}